<template>
  <b-container>
    <h4 class="text-center p-2 mt-4">
      <span class="mark-bottom">訂單查詢</span>
    </h4>
    <b-row class="mt-3">
      <b-col cols="12">
        <b-table id="self-deliver-table" :busy="isBusy" :items="items" :fields="fields" responsive="md" outlined class="text-center" bordered>
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(ops)="scope">
            <b-button size="sm" :to="`/deliver/${scope.item.id}`" class="btn-pur-dark">詳細</b-button>
          </template>
        </b-table>
        <b-pagination
          class="float-right"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="10"
          aria-controls="self-deliver-table"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import moment from 'moment'
import QueryString from 'querystring'
import { DeliverStates } from '../library/Var.js'
export default {
  data () {
    return {
      isBusy: false,
      items: [],
      currentPage: 1,
      rows: 0
    }
  },
  computed: {
    fields () {
      return [
        {key: 'uqid', label: '訂單編號' },
        {key: 'time', label: '訂購日期' },
        {key: 'total', label: '訂單金額' },
        {key: 'state', label: '訂單狀態' },
        {key: 'ops', label: '詳細' }
      ]
    },
    query () {
      const str = QueryString.stringify({
        page: this.page
      })
      return `?${str}`
    }
  },
  methods: {
    async fetch () {
      this.isBusy = true
      try {
        const { data, headers } = await this.$api.getMyDel(this.query)
        const page = Number.parseInt(headers['shop-option-page']) || 1
        const total = Number.parseInt(headers['shop-option-total']) || 0
        this.currentPage = page
        this.rows = total
        this.items = data.map(item => {
          const { id, time, state, total, uqid } = item
          return {
            id, uqid, time: moment(time).format('YYYY/MM/DD HH:mm:ss'), total, state: DeliverStates[state] || 'unknown'
          }
        })
      } catch (err) {
        console.log(err)
      }
      this.isBusy = false
    }
  },
  mounted () {
    this.fetch()
  }
}
</script>
<style>
  table tbody td {
	height: 31px;
    line-height: 31px;
  }
</style>
